module.exports = __webpack_public_path__ + "files/SPIADI2025 - Journée Nationale - Appel à communication.d52f3f0709f6d2c7a5b1f9750d983608.pdf";